import { createActions, createState, createReducer } from 'reduxsauce-crud'
import { clone } from 'ramda'
import moment from 'moment'

const sortMedicinesArray = (state, newMedicine) => {
  let newMedicines = [newMedicine, ...state.get.results]
  newMedicines = newMedicines.sort((medicineA, medicineB) => {
    const dateA = moment(medicineA.from_date)
    const dateB = moment(medicineB.from_date)
    return dateA.isBefore(dateB) ? 1 : -1
  })
  return newMedicines
}

const d = { deep: true }

export const MedicineRedux = createActions(
  {
    createMedicineRequest: ['medicineInfo'],
    createMedicineSuccess: ['response'],
    createMedicineError: ['err'],
  },
  {
    prefix: 'PARENT_PLATFORM_MEDICINE_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = MedicineRedux
export const MedicineTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  medicine: {
    fetching: false,
    result: null,
    error: null,
  },
}, {
  get: true,
})

const createMedicineRequest = state => state.merge({
  medicine: {
    fetching: true,
    result: null,
    error: null,
  },
}, d)
const createMedicineSuccess = (state, { response }) => {
  const newMedicines = sortMedicinesArray(state, response)
  return state.merge({
    medicine: {
      fetching: false,
      result: response,
      error: null,
    },
    get: {
      results: newMedicines,
    }
  }, d)
}
const createMedicineError = (state, { err }) => state.merge({
  medicine: {
    fetching: false,
    result: null,
    error: err,
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.createMedicineRequest]: createMedicineRequest,
    [Types.createMedicineSuccess]: createMedicineSuccess,
    [Types.createMedicineError]: createMedicineError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/MedicineRedux.js